import Bugsnag from '@bugsnag/js'
import { getPinoLogger } from './pino'

/**
 * Start Bugsnag
 */
export const start = async (bugsnagApiKey?: string, appEnv?: string, buildstamp?: string) => {
  if (appEnv === 'local' || !bugsnagApiKey || Bugsnag.isStarted()) return

  Bugsnag.start({
    apiKey: bugsnagApiKey,
    appVersion: buildstamp,
    plugins: [],
    releaseStage: appEnv,
    /**
     * Note, logger is only used when the log is sent to the console instead of BugSnag.
     * None of Pino's configuration options change/affect what BugSnag does.
     */
    logger: getPinoLogger(),
  })
}

/**
 * Returns the Bugsnag plugin for use with AWS Lambda functions.
 *
 * ! FYI, not sure if we currently use this. It might be a Vercel-only thing.
 */
export const getServerlessHandler = () => Bugsnag.getPlugin('awsLambda')?.createHandler()
